const config = window.externalCoursesResponseModel;

export default config;
